import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  const handleCTAClick = () => {
    const pricingSection = document.getElementById('pricing');
    pricingSection?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-gradient-to-b from-[#FBF9F6] to-white py-16 md:py-24 px-4" data-id="element-52">
      <div className="max-w-7xl mx-auto" data-id="element-53">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-54">
          {/* Text Content */}
          <motion.div className="order-2 lg:order-1" initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-55">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-6 leading-tight" data-id="element-56">
              No es malcrianza.
              <br data-id="element-57" />
              <span className="text-[#C7E0E7]" data-id="element-58">Es pánico practicado.</span>
            </h1>

            <div className="text-lg md:text-xl text-[#5C5C5C] mb-8 leading-relaxed" data-id="element-59">
              <p className="mb-4" data-id="element-60">
                Si tienes que negociar con tu propio baño porque tu perro no
                soporta que cierres una puerta… no estás solo.
              </p>
              <p className="mb-4" data-id="element-61">
                Y no: no significa que tu perro sea "dramático", ni que tú lo
                hayas "malacostumbrado" para siempre.
              </p>
              <p data-id="element-62">
                Significa algo más simple (y más incómodo):{' '}
                <strong className="text-[#2C2C2C]" data-id="element-63">
                  tu perro ha practicado entrar en alarma cada vez que
                  desapareces
                </strong>
                … y todavía no ha practicado lo contrario.
              </p>
            </div>

            <CTAButton onClick={handleCTAClick} ariaLabel="Descargar Plan" data-id="element-64">
              Descargar Plan
            </CTAButton>
          </motion.div>

          {/* Hero Image */}
          <motion.div className="order-1 lg:order-2" initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-65">
            <img src="https://cdn.magicpatterns.com/uploads/9DfxnXBUk3kcx73F64UohT/good_foto.png" alt="Mujer con su perro mirando la guía CALMA EN CASA en su teléfono" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-66" />
          </motion.div>
        </div>
      </div>
    </section>;
}